/**
 * tag-标签组件
 */
import { DEFAULT_DATA } from "@/config";

import "./index.less";

export interface TagProps {
  title?: string;
  titleStyle?: object;
  wrapStyle?: object;
}

const TagClassPrefix = "iot-component-tag";

const TagGroup = (props: TagProps) => {
  const { title = DEFAULT_DATA, wrapStyle = {}, titleStyle = {} } = props;

  return (
    <div className={`${TagClassPrefix}`} style={wrapStyle}>
      <span className={`${TagClassPrefix}-title`} style={titleStyle}>
        {title}
      </span>
    </div>
  );
};

export default TagGroup;
